import _includesInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/includes';
import React__default, { useRef, useMemo, useEffect } from 'react';
import styles from './92eaf70a5288baa390f98abe62f370ca7d0fa305958109435f118350410b09ae.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import { useDropdownContext } from './96f486109d0d2850b21eef94a8c44cc3323a66fb525ca5574171063673f9afca.cfe-internal.js';
import { useChildIndex } from './ChildIndexContext/c457595779a7ac9d386978c8bfe7a9c931826ac323551ee01f4fd049cfaec786.cfe-internal.js';
import '../../next/Input/b4bcb90162b6cc3db916cfd86172a50119c38c4caf8112c3c218ebcb4f058d0c.cfe-internal.js';
import '../../icons/index.es.js';
import useTranslation from '../../utils/Translation/de13cef5749fcd5a6a2788a56fd20c6a15d546ad2713851a9b628cd5aa481529.cfe-internal.js';
import { FlyoutOption } from '../../utils/Flyout/3d15f309681cace5995cf09f9b9fb203450e2015288fd6455e451778f8a421ad.cfe-internal.js';
import mergeRefs from '../../utils/mergeRefs/836dcb860bec00d9c59bd64df8df6df42430840bc5bfc21b6000935baefbeacd.cfe-internal.js';
import Input from '../../next/Input/a0540866ea1f38332ddf2d347e55fda96c7245ee277d55ed693fc3c1cd89d753.cfe-internal.js';
import SearchIcon from '../../icons/components/fd44f420e4f0cf097c788b0db805e5b1767bfe0b6caaa7e8803b476a89e57dbc.cfe-internal.js';

var DropdownSearch = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _useTranslation = useTranslation(),
    translate = _useTranslation.translate;
  var searchText = translate('searchText');
  var internalRef = useRef(null);
  var inputRef = useRef(null);
  var _useDropdownContext = useDropdownContext(),
    isOpen = _useDropdownContext.isOpen,
    highlightedIndex = _useDropdownContext.highlightedIndex,
    setIsKeyboardUser = _useDropdownContext.setIsKeyboardUser,
    setHighlightedIndex = _useDropdownContext.setHighlightedIndex,
    searchValue = _useDropdownContext.searchValue,
    setSearchValue = _useDropdownContext.setSearchValue,
    isKeyboardUser = _useDropdownContext.isKeyboardUser,
    setSearchHeight = _useDropdownContext.setSearchHeight;
  var handleSelect = function handleSelect() {
    var _inputRef$current;
    return (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
  };
  var myIndex = useChildIndex({
    element: internalRef.current,
    isVisible: true
  });
  var isHighlighted = useMemo(function () {
    return highlightedIndex === myIndex && myIndex !== -1;
  }, [highlightedIndex, myIndex]);
  useEffect(function () {
    // for keyboard navigation
    if (isHighlighted && isKeyboardUser) {
      var _inputRef$current2;
      (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.focus();
    }
  }, [isHighlighted, isKeyboardUser]);
  useEffect(function () {
    // for initial open with mouse
    if (isHighlighted && isOpen) {
      var _inputRef$current3;
      (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 || _inputRef$current3.focus();
    }
    // Omitted `isHighlighted` because we don't want to focus the input on mouse enter.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);
  useEffect(function () {
    if (isOpen) {
      var _internalRef$current;
      setSearchHeight((_internalRef$current = internalRef.current) === null || _internalRef$current === void 0 ? void 0 : _internalRef$current.offsetHeight);
    }
  }, [isOpen, setSearchHeight]);
  var handleKeyDown = function handleKeyDown(e) {
    var keysToAllow = ['ArrowDown', 'Escape', 'Tab', 'PageUp', 'Home', 'PageDown', 'End'];
    if (!_includesInstanceProperty(keysToAllow).call(keysToAllow, e.key)) {
      // `Dropdown` component listens for keystrokes to highlight options with matching labels. We want the focus to remain in the search bar.
      e.stopPropagation();
    }
  };
  var handleSearch = function handleSearch(e) {
    var searchVal = e.currentTarget.value;
    setSearchValue(searchVal);
  };
  var handleMouseEnter = function handleMouseEnter() {
    setHighlightedIndex(myIndex);
    setIsKeyboardUser(false);
  };
  var handleMouseLeave = function handleMouseLeave() {
    setHighlightedIndex(-1);
  };
  return isOpen ? /*#__PURE__*/React__default.createElement(FlyoutOption, {
    className: styles.search,
    ref: mergeRefs(internalRef, ref),
    tabIndex: -1,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onSelect: handleSelect
  }, /*#__PURE__*/React__default.createElement(Input, {
    className: styles.searchInput,
    onKeyDown: handleKeyDown,
    onChange: handleSearch,
    ref: inputRef,
    placeholder: searchText,
    leftAddOn: /*#__PURE__*/React__default.createElement(SearchIcon, {
      className: styles.searchIcon,
      "aria-hidden": true
    }),
    role: "searchbox",
    "aria-label": searchText,
    value: searchValue
  })) : /*#__PURE__*/React__default.createElement("div", {
    ref: internalRef
  });
});

export { DropdownSearch as default };
